<template>
  <div class="selec-tree-radio">
    <CheckBoxLimitLevel
      :childItems="dataList"
      :parentInd="parentInd"
      :parent-value.sync="queryInfo.list"
      @update:checkedValues="updateIndustryChecked"
      :isCheckBoxButton="isCheckBoxButton"
      :isRadioFirstLevel="isRadioFirstLevel"
      :vFeild="vFeild"
      :lFeild="lFeild"
      :cField="cField"
      :limitLabels="limitLabels"
      :isTree="isTree"
    >
    </CheckBoxLimitLevel>
  </div>
</template>
<script>
// components
import CheckBoxLimitLevel from "@/components/CheckBoxLimitLevel/index.vue";
// api
import {
  getIndustryList,
  getDicRadioButton,
  getIndustryLabelFour,
  getKnowTechList
} from "@/api/common.js";
import { getIndustryThree } from "@/api/Sceneknowledge.js";
// utils
import { getIndustryNames } from "@/utils/index.js";

const API = {
  getIndustryList,
  getDicRadioButton,
  getIndustryThree,
  getIndustryLabelFour,
  getKnowTechList
};

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    CheckBoxLimitLevel
  },
  props: {
    isTree: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ""
    },
    apiName: {
      type: String,
      default: ""
    },
    params: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 可选ids, values
    resultType: {
      type: String,
      default: "ids"
    },
    parentInd: {
      type: [Number, String],
      default: 1
    },
    vFeild: {
      type: String,
      default: "id"
    },
    lFeild: {
      type: String,
      default: "industryName"
    },
    cField: {
      type: String,
      default: "childNode"
    },
    storageKey: {
      type: String,
      default: ""
    },
    isRadioFirstLevel: {
      type: Boolean,
      default: true
    },
    isCheckBoxButton: {
      type: Boolean,
      default: true
    },
    value: {
      type: [String, Array],
      default: () => {
        return [];
      }
    },
    limitLabels: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    //这里存放数据
    return {
      queryInfo: {
        list: []
      },
      dataList: []
    };
  },
  watch: {
    value(value) {
      let tempArr;

      if (Array.isArray(value)) {
        if (this.apiName === "getDicRadioButton") {
          tempArr = getIndustryNames(
            value,
            this.dataList,
            "codeName",
            "codeId"
          );
        } else {
          tempArr = getIndustryNames(
            value,
            this.dataList,
            "industryName",
            "id"
          );
        }

        this.queryInfo.list = tempArr;
      } else {
        if (this.apiName === "getDicRadioButton") {
          tempArr = getIndustryNames(
            [value],
            this.dataList,
            "codeName",
            "codeId"
          );
        } else {
          tempArr = getIndustryNames(
            [value],
            this.dataList,
            "industryName",
            "id"
          );
        }

        this.queryInfo.list = tempArr;
      }
    }
  },
  //生命周期 - 创建完成(可以访问当前this实例)
  created() {
    if (this.apiName) {
      this.getData();
    }
  },
  //方法集合
  methods: {
    // 避免使用过多的 switch case 数据冗余
    async getData() {
      try {
        let storageValue;

        if (this.storageKey) {
          storageValue = sessionStorage.getItem(this.storageKey);
        }

        if (!storageValue) {
          const res = await API[this.apiName](this.params);

          if (res.code === 200 && res.data) {
            this.dataList = res.data;

            if (this.storageKey) {
              sessionStorage.setItem(this.storageKey, JSON.stringify(res.data));
            }
          }
        } else {
          this.dataList = JSON.parse(storageValue);
        }
      } catch (error) {
        console.error({
          components: "SelecTreeRadio",
          message: "获取数据出现错误",
          info: error
        });
      }
    },
    updateIndustryChecked(e) {
      let data;
      if (this.isTree) {
        if (this.resultType === "ids") {
          this.$emit("input", e);
        } else {
          if (this.apiName === "getDicRadioButton") {
            data = getIndustryNames(e, this.dataList, "codeId", "codeName");
          } else {
            data = getIndustryNames(e, this.dataList);
          }

          this.$emit(
            "input",
            data.filter(item => item)
          );
        }
      } else {
        if (Array.isArray(e) && e.length) {
          if (this.resultType === "ids") {
            data = e[0];
            this.$emit("input", data);
          } else {
            let tempArr;
            if (this.apiName === "getDicRadioButton") {
              tempArr = getIndustryNames(
                e,
                this.dataList,
                "codeId",
                "codeName"
              );
            } else {
              tempArr = getIndustryNames(e, this.dataList);
            }

            if (Array.isArray(tempArr) && tempArr.length) {
              data = tempArr[0];
              this.$emit("input", data);
            } else {
              this.$emit("input", "");
            }
          }
        } else {
          this.$emit("input", "");
        }
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
